import { refs } from './refs';

export function onSearchIconClick() {
  refs.headerSearch.classList.toggle('open');
}
